<mat-icon [matMenuTriggerFor]="popover" fontSet="material-icons-outlined" class="material-symbols-rounded custom-mat-menu-icon">edit</mat-icon>

<mat-menu #popover="matMenu" class="ngx-mat-popover container-modal-update-name" [hasBackdrop]="false">
  <ng-template matMenuContent>
    <div mat-menu-item [disableRipple]="true" (keydown.tab)="$event.stopPropagation()"
      (click)="$event.stopPropagation()" class="mat-popover">

      <div class="container-popover-template">
        <div class="modal-update-name__header">
          <p class="s1_500">{{ title }}</p>

          <button mat-icon-button (click)="onEventCancel($event)" aria-label="Close">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
          </button>
        </div>

        <div class="modal-update-name__body">

          <common-input-outline *ngIf="typeAction === 'input'" [placeholder]="'maia.servers.filters.search' | translate"
            [customIconRight]="'search'" (outputSearch)="onEventSearch($event)"></common-input-outline>

          <select-outline *ngIf="typeAction === 'select'" [disabled]="false" [floatLabelType]="floatLabelType"
            [typeSearch]="'local'" [label]="'maia.servers.detailsServer.statusServer' | translate"
            [customIconRight]="'search'" (outputSelect)="onEventSelect($event)" [options]="options" [valueFn]="valueFn"
            [displayFn]="displayFn"></select-outline>
        </div>

        <div class="modal-update-name__footer">

          <common-buttons-outlined class="filters-left-create-server" [label]="labelButtonCancel" [iconPosition]="false"
            (output)="onEventCancel($event)"></common-buttons-outlined>

          <common-buttons-filled class="filters-rigth-create-server" [label]="labelButtonSave" [disabled]="false"
            (output)="onEventSave($event)"></common-buttons-filled>
        </div>
      </div>
    </div>
  </ng-template>
</mat-menu>